import React from 'react';
import PropTypes from 'prop-types';
import Loading from '../Loading';
import DropdownOption from '../DropdownOption';
import { getLocale } from '../locale';
import ConfigConsumer from '../ConfigConsumer';
export default function SelectSearchList(_ref) {
  var children = _ref.children,
      loading = _ref.loading,
      onClickEmpty = _ref.onClickEmpty,
      empty = _ref.empty;
  return /*#__PURE__*/React.createElement("div", {
    className: "jmtd-select-search-list",
    onClick: function onClick() {
      if (empty || loading) {
        onClickEmpty(false);
      }
    }
  }, loading ? /*#__PURE__*/React.createElement(DropdownOption, {
    className: "jmtd-select-search-list-placeholder"
  }, /*#__PURE__*/React.createElement(Loading, {
    className: "jmtd-select-search-list-loading",
    size: "mini",
    loading: true
  })) : empty ? /*#__PURE__*/React.createElement(DropdownOption, {
    className: "jmtd-select-search-list-placeholder"
  }, /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    return getLocale(locale).common.noData;
  })) : children);
}
SelectSearchList.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  onClickEmpty: PropTypes.func,
  empty: PropTypes.bool
};
SelectSearchList.defaultProps = {
  children: null,
  loading: false,
  onClickEmpty: function onClickEmpty() {},
  empty: false
};